import React from "react";
import { Box } from "@mui/material";
import AppBar from "../../components/DefaultAppBar";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import TicketCreateButton from "./TicketCreateButton";
import TicketListContainer from "./TicketListContainer";

export const route = "/tickets";

const TicketListScreen = () => {
  return (
    <Box>
      <AppBar position="static">
        <LocationFilterToolbar />
      </AppBar>

      <TicketListContainer />

      <TicketCreateButton />
    </Box>
  );
};

TicketListScreen.route = route;

export default TicketListScreen;
